module.exports = __webpack_public_path__ + "static/media/sample-of-certificate-S355NL.766b15ea.jpg";